import { DisciplineSchedule } from '../../Components/DisciplineSchedule';

export const NRAActionPistolSchedule = () => {
  return (
    <DisciplineSchedule 
      discipline="NRA_ACTION_PISTOL" 
      disciplineName="NRA Action Pistol"
    />
  );
};
